import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-status",
  "use": "icon-status-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-status\">\n    <circle cx=\"12\" cy=\"12\" r=\"1\" fill=\"#6B778C\" />\n    <circle cx=\"12\" cy=\"9\" r=\"1\" fill=\"#42526E\" />\n    <circle cx=\"12\" cy=\"15\" r=\"1\" fill=\"#B5BBC5\" />\n    <path d=\"M8 6C8 5.44772 8.44772 5 9 5H15C15.5523 5 16 5.44772 16 6V18C16 18.5523 15.5523 19 15 19H9C8.44772 19 8 18.5523 8 18V6Z\" stroke=\"currentColor\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol